import { object } from 'valibot'

import { stringToNumber } from '@/libs/valibot'

export const packageCategoryParamsSchema = object({
  packageCategoryId: stringToNumber()
})
